export class GroupPreferenceUpdateDto {
    id: number;
    ehiGroupId: number;
    goalName: string;
    sequence: number;
    recordStatus: boolean;
    updatedBy: string;
}
